import { capitalize } from "lodash";

import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Badge, ItemIcon, Type } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import TagsBadge from "app/pages/sales-intelligence/common-components/TagsBadge/TagsBadge";
import { getFaviconUrl } from "app/services/sitesService/sitesUtils";

import type { WaterfallProvider } from "../../types/contacts-providers";

import { WaterfallCard } from "./WaterfallCard";

type ProviderCardProps = {
    readonly rank: number;
    readonly provider: WaterfallProvider;
};

export const ProviderCard = ({ rank, provider }: ProviderCardProps) => {
    const { translate } = useTranslate();

    return (
        <WaterfallCard
            rank={rank}
            dataAutomation={`contacts-waterfall-card-${provider.domain}`}
            logo={
                <Flex flexShrink="0">
                    <ItemIcon
                        iconType={Type.Website}
                        iconSrc={getFaviconUrl(provider.domain)}
                    />
                </Flex>
            }
            content={
                <Stack
                    flex="1"
                    minWidth="0"
                    gap="4px"
                >
                    <Flex
                        gap="14px"
                        alignItems="center"
                    >
                        <Text
                            fontVariant="subtitle1"
                            color={colorsPalettes.bluegrey[600]}
                        >
                            {provider.name}
                        </Text>
                        {provider.creditCost ? (
                            <TagsBadge
                                text={capitalize(translate(provider.creditCost))}
                                dataAutomationType="contacts-waterfall-credit-cost"
                                size="small"
                                bgColor={colorsPalettes.carbon[0]}
                            />
                        ) : null}
                    </Flex>
                    <Text
                        fontVariant="listItem3"
                        color={colorsPalettes.carbon[300]}
                    >
                        {translate(provider.descriptionKey)}
                    </Text>
                </Stack>
            }
            action={
                <Badge
                    color={colorsPalettes.carbon["400"]}
                    bgColor={colorsPalettes.orange["100"]}
                >
                    <SWReactIcons
                        iconName="similar-icon"
                        size="10px"
                    />
                    {translate("si.pages.contacts_waterfall.managed")}
                </Badge>
            }
        />
    );
};
